export default __webpack_public_path__ + "static/media/pichlane-log.1fc493f8.svg";